<template>
  <v-row no-gutters>
    <v-col cols="12">
      <span
        class="text-body-2 font-weight-bold title-color"
        v-text="data.title"
      />
    </v-col>
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12">
          <v-list v-if="type=='default'">
            <v-list-item
              v-for="(item,index) in data.info"
              :key="index"
              :class="{'list-padding-sp': $vuetify.breakpoint.xs}"
            >
              <v-list-item-content>
                <span
                  class="text-body-2"
                  v-text="item"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-if="type=='numbered'">
            <v-list-item
              v-for="(item,index) in data.info"
              :key="index"
              :class="{'list-padding-sp': $vuetify.breakpoint.xs}"
            >
              <v-list-item-avatar
                color="accent4"
                size="24"
                class="white--text text-body-2 avatar-position"
                v-text="index + 1"
              />
              <v-list-item-content>
                <span
                  class="text-body-2"
                  v-text="item"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-if="type=='numberedList'">
            <v-list-item :class="{'list-padding-sp': $vuetify.breakpoint.xs}">
              <v-list-item-content>
                <span class="text-body-2">{{ data.headerInfo }}</span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="(item,index) in data.info"
              :key="index"
              :class="{'list-padding-sp': $vuetify.breakpoint.xs}"
            >
              <v-list-item-avatar
                color="accent4"
                size="24"
                class="white--text text-body-2 avatar-position"
                v-text="index + 1"
              />
              <v-list-item-content>
                <span
                  class="text-body-2"
                  v-text="item"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-if="type=='list'">
            <v-list-item
              v-for="(item,index) in data.info"
              :key="index"
              :class="{'list-padding-sp': $vuetify.breakpoint.xs}"
            >
              <v-list-item-avatar
                color="accent4"
                size="24"
                class="white--text text-body-2 avatar-position"
                v-text="index + 1"
              />
              <v-list-item-content>
                <span
                  class="text-body-2"
                  v-text="item"
                />
                <div
                  v-if="index == data.listPosition"
                  class="mt-4"
                >
                  <v-row no-gutters>
                    <v-col cols="12">
                      <ol>
                        <li
                          v-for="(listItem, listIndex) in data.list"
                          :key="listIndex"
                          class="text-body-2 pb-2"
                        >
                          {{ listItem }}
                        </li>
                      </ol>
                    </v-col>
                  </v-row>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-if="type=='mixed'">
            <v-list-item
              v-for="(item,index) in data.info"
              :key="index"
              :class="{'list-padding-sp': $vuetify.breakpoint.xs}"
            >
              <v-list-item-avatar
                color="accent4"
                size="24"
                class="white--text text-body-2 avatar-position"
                v-text="index + 1"
              />
              <v-list-item-content>
                <span
                  class="text-body-2"
                  v-text="item.info"
                />
                <ol v-if="item.list">
                  <li
                    v-for="(listItem, indexList) in item.list"
                    :key="indexList"
                    class="text-body-2 py-2"
                  >
                    <span v-text="listItem.listText" />
                    <ol
                      v-if="listItem.details"
                      type="a"
                    >
                      <li
                        v-for="(detailItem, indexDetail) in listItem.details"
                        :key="indexDetail"
                        class="text-body-2 pb-2 py-1"
                        v-text="detailItem"
                      />
                    </ol>
                  </li>
                </ol>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-if="type=='letterList'">
            <v-list-item :class="{'list-padding-sp': $vuetify.breakpoint.xs}">
              <v-list-item-content>
                <span class="text-body-2">{{ data.headerInfo }}</span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="(item,index) in data.info"
              :key="index"
              :class="{'list-padding-sp': $vuetify.breakpoint.xs}"
            >
              <v-list-item-avatar
                color="accent4"
                size="24"
                class="white--text text-body-2 avatar-position"
                v-text="index + 1"
              />
              <v-list-item-content>
                <span
                  class="text-body-2"
                  v-text="item"
                />
                <div
                  v-if="index == data.listPosition"
                  class="mt-4"
                >
                  <v-row no-gutters>
                    <v-col
                      cols="12"
                    >
                      <ol type="a">
                        <li
                          v-for="(listItem, listIndex) in data.list"
                          :key="listIndex"
                          class="text-body-2 pb-2"
                        >
                          {{ listItem }}
                        </li>
                      </ol>
                    </v-col>
                  </v-row>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: Object
    },
    type: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style scoped>
.avatar-position {
  align-self: normal !important;
  margin-top: 11px !important;
}
.title-color {
  color: var(--v-article-base) !important;
}
.list-padding-sp {
  padding: 0px !important;
}
</style>
